<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#ff0000">
  <defs>
    <style>.cls-1{display:none;}</style>
  </defs>
  <g id="transparent_box">
    <rect class="cls-1" width="32" height="32"/>
  </g>
  <g id="OUTLINE">
    <rect x="15" y="13" width="2" height="7"/>
    <path d="M16,22a1.5,1.5,0,1,0,1.53,1.49A1.49,1.49,0,0,0,16,22Z"/>
    <path d="M16,2,.26,29H31.74Zm0,4L28.26,27H3.74Z"/>
  </g>
</svg>
